import axios from 'axios'
import store from '~/store'
import router from '~/common/router'
import {
    Message,
    MessageBox
} from 'element-ui'
import AccountService from '~/services/account'

// 服务端域名URL
const BASE_URL = '/';
const ACCESS_TOKEN_PARAM = 'access-token'

/**
 * 实例化 axios 对象
 * @type {AxiosInstance}
 */
const service = axios.create({
    baseURL: BASE_URL, // 基础路径
    timeout: 120000 // 请求超时时间 这里 120000 == 120 秒
});

/**
 * 请求拦截器
 * 当发送http请求时触发执行
 */
service.interceptors.request.use(req => {
    // 在每次发起请求前进行拦截在请求头中加入 AccessToken 确保每次请求都能通过身份验证
    const accessToken = AccountService.getAccessTokenByCache();
    if (accessToken) {
        req.headers[ACCESS_TOKEN_PARAM] = accessToken;
    }
    return req;
}, error => {
    // 对请求错误做相应处理
    return Promise.reject(error);
});

/**
 * 响应拦截器
 * 当得到http请求响应时触发执行
 */
service.interceptors.response.use(res => {

    // 统一处理解析响应结果
    const data = res.data;
    if (data.code == 0 || data.code == 200) {
        return data;
    } else {

        // 用户未登录引导至登录页面
        if (data.code == 4003) {
            showMessage('error', '身份非法', '系统检测到您的身份信息非法，已被强制下线，请重新登录');
        } else if (data.code == 4001) {
            showMessage('error', '登录信息已过期', '由于您长时间未操作登录信息已过期失效，请重新登录');
        } else if (data.code == 4022) {
            showMessage('error', '登录受限', data.msg);
        } else if (data.code == 4220) {
            // 服务端需要自定义处理的错误
            return data;
        } else if (data.code == 403) {
            // 如果服务端响应 403 状态 则说明对请求接口无权访问，服务端将跳转至 403 页面
            router.push({path: '/403'})
        } else if (data.code == 404) {
            router.push({path: '/404'})
        } else if (data.code == 404) {
            router.push({path: '/404'})
        } else if (data.code == 405) {
            //导入异常反回提示数据，特殊处理不自动关闭弹窗提示
            Message({
                message: data.msg,
                type: 'error',
                showClose: true,
                center: true,
                dangerouslyUseHTMLString: true,
                duration: 0
            })
        } else {
            Message({
                message: data.msg,
                type: 'error',
                showClose: true,
            })
        }

        return data;
    }

}, error => {
    let msg = error.toString();
    // 监听错误信息中的

    // 对响应错误做相应处理
    return Promise.reject(error);
});

/**
 * 显示重新登录的提示，点击确定后该方法会强制注销登录
 * @param type 消息内容
 * @param title 消息标题
 * @param content 消息内容
 */
function showMessage(type, title, content) {
    MessageBox.alert(
        content,
        title, {
            confirmButtonText: '重新登录',
            showClose: false,
            type: type
        }).then(() => {
        store.dispatch('logout').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
        })
    })
}

export default service;


// WEBPACK FOOTER //
// ./src/common/http.js